// Hero Banner component
const HeroBanner = () => {
    // Return if not on desktop
    if (window.innerWidth < 1199.98) return;

    // Getting hero banner instance
    const hero = document.getElementById('heroBanner');

    // Hero banner exist and not animated
    if (hero && !hero.classList.contains('animated')) {
        document.body.style.overflow = 'hidden';
        document.body.style.height = '100vh';
    }

    // Method to handle scroll
    const onScroll = () => {
        // Return in hero is animated already
        if (hero.classList.contains('animated')) return;

        // Adding sticky class to header
        hero.classList.add('animated');
        // Open scroll events
        setTimeout(() => {
            document.body.style.overflow = 'unset';
            document.body.style.height = 'auto';
        }, 1500);
    };

    // Wheel event
    var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

    // if not already animated
    if (!hero.classList.contains('animated')) {        
        // Adding scroll event listener for scroll event
        window.addEventListener('DOMMouseScroll', onScroll, false); // older FF
        window.addEventListener(wheelEvent, onScroll, { passive: false }); // modern desktop
        window.addEventListener('touchmove', onScroll, { passive: false }); // mobile
    }
};

// Export component
export default HeroBanner;